import { render, staticRenderFns } from "./AverageArWidget.vue?vue&type=template&id=67cc8b9f&scoped=true&"
import script from "./AverageArWidget.vue?vue&type=script&lang=js&"
export * from "./AverageArWidget.vue?vue&type=script&lang=js&"
import style0 from "./AverageArWidget.vue?vue&type=style&index=0&id=67cc8b9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cc8b9f",
  null
  
)

export default component.exports